<script lang="ts" setup>
// @ts-expect-error JS library
import { useMq } from 'vue3-mq'
import { storeToRefs } from 'pinia'
import { useRadar } from '~/store/radar'
import { useRoot } from '~/store'
import CertsAlpha from '~/components/page/certs/Alpha.vue'
import CertsBeta from '~/components/page/certs/Beta.vue'
import CertsGamma from '~/components/page/certs/Gamma.vue'
import CertsDelta from '~/components/page/certs/Delta.vue'
import CertsEpsilon from '~/components/page/certs/Epsilon.vue'
import CertsZeta from '~/components/page/certs/Zeta.vue'
import CertsEta from '~/components/page/certs/Eta.vue'

const page = 'certs'

const radar = useRadar()
const { setScrollStatus } = useRoot()
const { t } = useI18n()
const { xs, sm } = useMq()
const i18nHead = useLocaleHead()

useSeoMeta({
  title: () => t(`routes.${page}.title`),
  ogTitle: () => t(`routes.${page}.title`),
  description: () => t(`routes.${page}.description`),
  ogDescription: () => t(`routes.${page}.description`)
})

useHead(i18nHead.value)

useStructuredData(page)

const { routeComponents } = storeToRefs(radar)

const components = [CertsAlpha, CertsBeta, CertsGamma, CertsDelta, CertsEpsilon, CertsZeta, CertsEta]

radar.setRouteComponents(components)

onMounted(() => {
  if (xs || sm) setScrollStatus(false)
})

onBeforeUnmount(() => {
  setScrollStatus(true)
})
</script>

<template lang="pug">
LayoutGrid(:class="page")
  template(
    v-for="(component, index) in routeComponents"
    :key="`component-${index}`"
    #[component?.letter?.word]
  )
    component(:is="component.component")
</template>
